import { render, staticRenderFns } from "./BloodTypeBtns.vue?vue&type=template&id=fb57ec30&"
import script from "./BloodTypeBtns.vue?vue&type=script&lang=js&"
export * from "./BloodTypeBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports